import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMapActive = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.3 21.5L8.725 19.175L4.25 20.95C3.96667 21.1 3.6875 21.0917 3.4125 20.925C3.1375 20.7583 3 20.5083 3 20.175V6.225C3 6.00833 3.0625 5.81667 3.1875 5.65C3.3125 5.48333 3.475 5.35833 3.675 5.275L8.725 3.5L15.3 5.8L19.75 4.025C20.0333 3.89167 20.3125 3.90417 20.5875 4.0625C20.8625 4.22083 21 4.46667 21 4.8V18.925C21 19.1083 20.9375 19.2667 20.8125 19.4C20.6875 19.5333 20.5333 19.6333 20.35 19.7L15.3 21.5ZM14.45 19.625V7L9.55 5.35V17.975L14.45 19.625ZM15.95 19.625L19.5 18.45V5.65L15.95 7V19.625ZM4.5 19.325L8.05 17.975V5.35L4.5 6.525V19.325Z",
		fill: "#118AB2",
		stroke: "#118AB2",
		strokeWidth: .5
	})
});
export default SvgMapActive;
